import { connect } from "react-redux";
import EventSalary from './eventSalary'
import { bindActionCreators } from "redux";
import {getValetEventSalary, approveValetEventSalary} from "../../../services/redux/Valet/Project/action";
const mapStateToProps = (state) => ({
    eventSalaryList : state.CreateProject.eventSalaryList,
    approveSalary: state.CreateProject.approveSalary,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getValetEventSalary,
        approveValetEventSalary
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventSalary);
